
export const param_HT = "High °C";
export const param_MT = "Mean °C";
export const param_LT = "Low °C";
export const param_Rm = "Rain mm";
export const param_Rd = "Rain days";

export const locationData = 

[
  {
    "id": 1,
    "location": "Bali",
    "param": "High °C",
    "jan": 33,
    "feb": 33.4,
    "mar": 33.6,
    "apr": 34.4,
    "may": 33.1,
    "jun": 31.4,
    "jul": 30.4,
    "aug": 29.6,
    "sep": 31.4,
    "oct": 33.6,
    "nov": 32.7,
    "dec": 33,
    "year": 32.47
  },
  {
    "id": 2,
    "location": "Bali",
    "param": "Mean °C",
    "jan": 28.55,
    "feb": 28.8,
    "mar": 28.8,
    "apr": 29.6,
    "may": 28.6,
    "jun": 27.45,
    "jul": 26.7,
    "aug": 26.05,
    "sep": 27.15,
    "oct": 28.65,
    "nov": 28.1,
    "dec": 28.25,
    "year": 28.06
  },
  {
    "id": 3,
    "location": "Bali",
    "param": "Low °C",
    "jan": 24.1,
    "feb": 24.2,
    "mar": 24,
    "apr": 24.8,
    "may": 24.1,
    "jun": 23.5,
    "jul": 23,
    "aug": 22.5,
    "sep": 22.9,
    "oct": 23.7,
    "nov": 23.5,
    "dec": 23.5,
    "year": 23.65
  },
  {
    "id": 4,
    "location": "Bali",
    "param": "Rain mm",
    "jan": 345,
    "feb": 274,
    "mar": 234,
    "apr": 88,
    "may": 93,
    "jun": 53,
    "jul": 55,
    "aug": 25,
    "sep": 47,
    "oct": 63,
    "nov": 179,
    "dec": 276,
    "year": 1732
  },
  {
    "id": 5,
    "location": "Bali",
    "param": "Rain days",
    "jan": 27,
    "feb": 22,
    "mar": 20,
    "apr": 9,
    "may": 8,
    "jun": 6,
    "jul": 4,
    "aug": 4,
    "sep": 8,
    "oct": 12,
    "nov": 16,
    "dec": 22,
    "year": 158
  },
  {
    "id": 6,
    "location": "Bangkok",
    "param": "High °C",
    "jan": 32.5,
    "feb": 33.3,
    "mar": 34.3,
    "apr": 35.4,
    "may": 34.4,
    "jun": 33.6,
    "jul": 33.2,
    "aug": 32.9,
    "sep": 32.8,
    "oct": 32.6,
    "nov": 32.4,
    "dec": 31.7,
    "year": 33.3
  },
  {
    "id": 7,
    "location": "Bangkok",
    "param": "Mean °C",
    "jan": 27.6,
    "feb": 28.9,
    "mar": 30.1,
    "apr": 31.2,
    "may": 30.5,
    "jun": 29.9,
    "jul": 29.5,
    "aug": 29.2,
    "sep": 28.9,
    "oct": 28.7,
    "nov": 28.1,
    "dec": 26.9,
    "year": 29.13
  },
  {
    "id": 8,
    "location": "Bangkok",
    "param": "Low °C",
    "jan": 22.6,
    "feb": 24.4,
    "mar": 25.9,
    "apr": 26.9,
    "may": 26.3,
    "jun": 26.1,
    "jul": 25.7,
    "aug": 25.5,
    "sep": 25,
    "oct": 24.8,
    "nov": 23.9,
    "dec": 22,
    "year": 24.9
  },
  {
    "id": 9,
    "location": "Bangkok",
    "param": "Rain mm",
    "jan": 13.3,
    "feb": 20,
    "mar": 42.1,
    "apr": 91.4,
    "may": 247.7,
    "jun": 157.1,
    "jul": 175.1,
    "aug": 219.3,
    "sep": 334.3,
    "oct": 292.1,
    "nov": 49.5,
    "dec": 6.3,
    "year": 1648.2
  },
  {
    "id": 10,
    "location": "Bangkok",
    "param": "Rain days",
    "jan": 1,
    "feb": 3,
    "mar": 3,
    "apr": 6,
    "may": 16,
    "jun": 16,
    "jul": 18,
    "aug": 20,
    "sep": 21,
    "oct": 17,
    "nov": 6,
    "dec": 1,
    "year": 128
  },
  {
    "id": 11,
    "location": "Hong Kong",
    "param": "High °C",
    "jan": 18.6,
    "feb": 18.9,
    "mar": 21.4,
    "apr": 25,
    "may": 28.4,
    "jun": 30.2,
    "jul": 31.4,
    "aug": 31.1,
    "sep": 30.1,
    "oct": 27.8,
    "nov": 24.1,
    "dec": 20.2,
    "year": 25.6
  },
  {
    "id": 12,
    "location": "Hong Kong",
    "param": "Mean °C",
    "jan": 16.3,
    "feb": 16.8,
    "mar": 19.1,
    "apr": 22.6,
    "may": 25.9,
    "jun": 27.9,
    "jul": 28.8,
    "aug": 28.6,
    "sep": 27.7,
    "oct": 25.5,
    "nov": 21.8,
    "dec": 17.9,
    "year": 23.24
  },
  {
    "id": 13,
    "location": "Hong Kong",
    "param": "Low °C",
    "jan": 14.5,
    "feb": 15,
    "mar": 17.2,
    "apr": 20.8,
    "may": 24.1,
    "jun": 26.2,
    "jul": 26.8,
    "aug": 26.6,
    "sep": 25.8,
    "oct": 23.7,
    "nov": 19.8,
    "dec": 15.9,
    "year": 21.4
  },
  {
    "id": 14,
    "location": "Hong Kong",
    "param": "Rain mm",
    "jan": 24.7,
    "feb": 54.4,
    "mar": 82.2,
    "apr": 174.7,
    "may": 304.7,
    "jun": 456.1,
    "jul": 376.5,
    "aug": 432.2,
    "sep": 327.6,
    "oct": 100.9,
    "nov": 37.6,
    "dec": 26.8,
    "year": 2398.4
  },
  {
    "id": 15,
    "location": "Hong Kong",
    "param": "Rain days",
    "jan": 5.37,
    "feb": 9.07,
    "mar": 10.9,
    "apr": 12,
    "may": 14.67,
    "jun": 19.07,
    "jul": 17.6,
    "aug": 16.93,
    "sep": 14.67,
    "oct": 7.43,
    "nov": 5.47,
    "dec": 4.47,
    "year": 137.65
  },
  {
    "id": 16,
    "location": "Hanoi",
    "param": "High °C",
    "jan": 19.7,
    "feb": 20.1,
    "mar": 22.9,
    "apr": 27.2,
    "may": 31.4,
    "jun": 32.9,
    "jul": 33.1,
    "aug": 32.3,
    "sep": 31.2,
    "oct": 28.8,
    "nov": 25.3,
    "dec": 22,
    "year": 27.2
  },
  {
    "id": 17,
    "location": "Hanoi",
    "param": "Mean °C",
    "jan": 16.4,
    "feb": 17.2,
    "mar": 20,
    "apr": 23.9,
    "may": 27.4,
    "jun": 28.9,
    "jul": 29.2,
    "aug": 28.6,
    "sep": 27.5,
    "oct": 24.9,
    "nov": 21.5,
    "dec": 18.2,
    "year": 23.6
  },
  {
    "id": 18,
    "location": "Hanoi",
    "param": "Low °C",
    "jan": 14.3,
    "feb": 15.3,
    "mar": 18.1,
    "apr": 21.7,
    "may": 24.6,
    "jun": 26.1,
    "jul": 26.3,
    "aug": 26,
    "sep": 24.9,
    "oct": 22.3,
    "nov": 18.9,
    "dec": 15.6,
    "year": 21.2
  },
  {
    "id": 19,
    "location": "Hanoi",
    "param": "Rain mm",
    "jan": 18,
    "feb": 19,
    "mar": 34,
    "apr": 105,
    "may": 165,
    "jun": 266,
    "jul": 253,
    "aug": 274,
    "sep": 243,
    "oct": 156,
    "nov": 59,
    "dec": 20,
    "year": 1612
  },
  {
    "id": 20,
    "location": "Hanoi",
    "param": "Rain days",
    "jan": 10.3,
    "feb": 12.4,
    "mar": 16,
    "apr": 14.4,
    "may": 14.5,
    "jun": 14.6,
    "jul": 15.6,
    "aug": 16.9,
    "sep": 13.6,
    "oct": 10.9,
    "nov": 7.9,
    "dec": 5,
    "year": 152.1
  },
  {
    "id": 21,
    "location": "Ho Chi Minh City",
    "param": "High °C",
    "jan": 31.6,
    "feb": 32.9,
    "mar": 33.9,
    "apr": 34.6,
    "may": 34,
    "jun": 32.4,
    "jul": 32,
    "aug": 31.8,
    "sep": 31.3,
    "oct": 31.2,
    "nov": 31,
    "dec": 30.8,
    "year": 32.3
  },
  {
    "id": 22,
    "location": "Ho Chi Minh City",
    "param": "Mean °C",
    "jan": 26,
    "feb": 26.8,
    "mar": 28,
    "apr": 29.2,
    "may": 28.8,
    "jun": 27.8,
    "jul": 27.5,
    "aug": 27.4,
    "sep": 27.2,
    "oct": 27,
    "nov": 26.7,
    "dec": 26,
    "year": 27.4
  },
  {
    "id": 23,
    "location": "Ho Chi Minh City",
    "param": "Low °C",
    "jan": 21.1,
    "feb": 22.5,
    "mar": 24.4,
    "apr": 25.8,
    "may": 25.2,
    "jun": 24.6,
    "jul": 24.3,
    "aug": 24.3,
    "sep": 24.4,
    "oct": 23.9,
    "nov": 22.8,
    "dec": 21.4,
    "year": 23.7
  },
  {
    "id": 24,
    "location": "Ho Chi Minh City",
    "param": "Rain mm",
    "jan": 13.8,
    "feb": 4.1,
    "mar": 10.5,
    "apr": 50.4,
    "may": 218.4,
    "jun": 311.7,
    "jul": 293.7,
    "aug": 269.8,
    "sep": 327.1,
    "oct": 266.7,
    "nov": 116.5,
    "dec": 48.3,
    "year": 1931
  },
  {
    "id": 25,
    "location": "Ho Chi Minh City",
    "param": "Rain days",
    "jan": 2.4,
    "feb": 1,
    "mar": 1.9,
    "apr": 5.4,
    "may": 17.8,
    "jun": 19,
    "jul": 22.9,
    "aug": 22.4,
    "sep": 23.1,
    "oct": 20.9,
    "nov": 12.1,
    "dec": 6.7,
    "year": 155.6
  },
  {
    "id": 26,
    "location": "Jakarta",
    "param": "High °C",
    "jan": 28.9,
    "feb": 28.9,
    "mar": 29.4,
    "apr": 30,
    "may": 30.6,
    "jun": 30,
    "jul": 30,
    "aug": 30.6,
    "sep": 31.1,
    "oct": 31.1,
    "nov": 30.6,
    "dec": 29.4,
    "year": 30.1
  },
  {
    "id": 27,
    "location": "Jakarta",
    "param": "Mean °C",
    "jan": 26.1,
    "feb": 26.1,
    "mar": 26.4,
    "apr": 27,
    "may": 27.2,
    "jun": 26.7,
    "jul": 26.4,
    "aug": 26.7,
    "sep": 27,
    "oct": 27.2,
    "nov": 27,
    "dec": 26.4,
    "year": 26.7
  },
  {
    "id": 28,
    "location": "Jakarta",
    "param": "Low °C",
    "jan": 23.3,
    "feb": 23.3,
    "mar": 23.3,
    "apr": 23.9,
    "may": 23.9,
    "jun": 23.3,
    "jul": 22.8,
    "aug": 22.8,
    "sep": 22.8,
    "oct": 23.3,
    "nov": 23.3,
    "dec": 23.3,
    "year": 23.3
  },
  {
    "id": 29,
    "location": "Jakarta",
    "param": "Rain mm",
    "jan": 299.7,
    "feb": 299.7,
    "mar": 210.8,
    "apr": 147.3,
    "may": 132.1,
    "jun": 96.5,
    "jul": 63.5,
    "aug": 43.2,
    "sep": 66,
    "oct": 111.8,
    "nov": 142.2,
    "dec": 203.2,
    "year": 1816
  },
  {
    "id": 30,
    "location": "Kuala Lumpur",
    "param": "High °C",
    "jan": 32,
    "feb": 32.8,
    "mar": 33.1,
    "apr": 33.1,
    "may": 33,
    "jun": 32.8,
    "jul": 32.8,
    "aug": 32.3,
    "sep": 32.1,
    "oct": 32,
    "nov": 31.7,
    "dec": 31.5,
    "year": 32.4
  },
  {
    "id": 31,
    "location": "Kuala Lumpur",
    "param": "Mean °C",
    "jan": 27.7,
    "feb": 28.2,
    "mar": 28.6,
    "apr": 28.7,
    "may": 28.8,
    "jun": 28.6,
    "jul": 28.1,
    "aug": 28.1,
    "sep": 28,
    "oct": 28,
    "nov": 27.8,
    "dec": 27.6,
    "year": 28.2
  },
  {
    "id": 32,
    "location": "Kuala Lumpur",
    "param": "Low °C",
    "jan": 23.4,
    "feb": 23.6,
    "mar": 24,
    "apr": 24.3,
    "may": 24.6,
    "jun": 24.3,
    "jul": 23.8,
    "aug": 23.9,
    "sep": 23.8,
    "oct": 24,
    "nov": 23.8,
    "dec": 23.6,
    "year": 23.9
  },
  {
    "id": 33,
    "location": "Kuala Lumpur",
    "param": "Rain mm",
    "jan": 193,
    "feb": 198,
    "mar": 257,
    "apr": 290,
    "may": 197,
    "jun": 131,
    "jul": 148,
    "aug": 162,
    "sep": 214,
    "oct": 265,
    "nov": 321,
    "dec": 252,
    "year": 2628
  },
  {
    "id": 34,
    "location": "Kuala Lumpur",
    "param": "Rain days",
    "jan": 17,
    "feb": 17,
    "mar": 19,
    "apr": 20,
    "may": 18,
    "jun": 14,
    "jul": 16,
    "aug": 16,
    "sep": 19,
    "oct": 21,
    "nov": 24,
    "dec": 22,
    "year": 223
  },
  {
    "id": 35,
    "location": "Manila",
    "param": "High °C",
    "jan": 29.6,
    "feb": 30.5,
    "mar": 31.9,
    "apr": 33.3,
    "may": 34.4,
    "jun": 33.5,
    "jul": 32.4,
    "aug": 32.3,
    "sep": 32.1,
    "oct": 31.4,
    "nov": 30.5,
    "dec": 29.8,
    "year": 31.1
  },
  {
    "id": 36,
    "location": "Manila",
    "param": "Mean °C",
    "jan": 25.6,
    "feb": 25.9,
    "mar": 26.7,
    "apr": 27.9,
    "may": 29.2,
    "jun": 29.1,
    "jul": 28.9,
    "aug": 28.8,
    "sep": 28.2,
    "oct": 27.1,
    "nov": 26,
    "dec": 25.9,
    "year": 28.4
  },
  {
    "id": 37,
    "location": "Manila",
    "param": "Low °C",
    "jan": 21.2,
    "feb": 21.3,
    "mar": 21.4,
    "apr": 22.5,
    "may": 24.9,
    "jun": 26.4,
    "jul": 25.8,
    "aug": 25.4,
    "sep": 24.6,
    "oct": 23.3,
    "nov": 22.2,
    "dec": 21.6,
    "year": 23.6
  },
  {
    "id": 38,
    "location": "Manila",
    "param": "Rain mm",
    "jan": 17.3,
    "feb": 14.2,
    "mar": 15.8,
    "apr": 23.7,
    "may": 147.2,
    "jun": 253.5,
    "jul": 420.5,
    "aug": 432.4,
    "sep": 355.1,
    "oct": 234.8,
    "nov": 121.7,
    "dec": 67.4,
    "year": 2103.6
  },
  {
    "id": 39,
    "location": "Manila",
    "param": "Rain days",
    "jan": 4,
    "feb": 3,
    "mar": 3,
    "apr": 4,
    "may": 10,
    "jun": 17,
    "jul": 21,
    "aug": 21,
    "sep": 20,
    "oct": 17,
    "nov": 12,
    "dec": 7,
    "year": 139
  },
  {
    "id": 40,
    "location": "Phuket",
    "param": "High °C",
    "jan": 32.7,
    "feb": 33.6,
    "mar": 34,
    "apr": 33.9,
    "may": 32.8,
    "jun": 32.4,
    "jul": 32,
    "aug": 32,
    "sep": 31.5,
    "oct": 31.5,
    "nov": 31.7,
    "dec": 31.7,
    "year": 32.48
  },
  {
    "id": 41,
    "location": "Phuket",
    "param": "Mean °C",
    "jan": 28.6,
    "feb": 29.25,
    "mar": 29.7,
    "apr": 29.85,
    "may": 29.2,
    "jun": 28.95,
    "jul": 28.55,
    "aug": 28.65,
    "sep": 28.05,
    "oct": 28,
    "nov": 28.2,
    "dec": 28.05,
    "year": 28.75
  },
  {
    "id": 42,
    "location": "Phuket",
    "param": "Low °C",
    "jan": 24.5,
    "feb": 24.9,
    "mar": 25.4,
    "apr": 25.8,
    "may": 25.6,
    "jun": 25.5,
    "jul": 25.1,
    "aug": 25.3,
    "sep": 24.6,
    "oct": 24.5,
    "nov": 24.7,
    "dec": 24.4,
    "year": 25.02
  },
  {
    "id": 43,
    "location": "Phuket",
    "param": "Rain mm",
    "jan": 30.3,
    "feb": 23.9,
    "mar": 73.5,
    "apr": 142.9,
    "may": 259.5,
    "jun": 213.3,
    "jul": 258.2,
    "aug": 286.8,
    "sep": 361.2,
    "oct": 320.1,
    "nov": 177.4,
    "dec": 72.4,
    "year": 2219.5
  },
  {
    "id": 44,
    "location": "Phuket",
    "param": "Rain days",
    "jan": 4,
    "feb": 3,
    "mar": 5,
    "apr": 11,
    "may": 21,
    "jun": 19,
    "jul": 19,
    "aug": 19,
    "sep": 23,
    "oct": 22,
    "nov": 16,
    "dec": 8,
    "year": 170
  },
  {
    "id": 45,
    "location": "Seoul",
    "param": "High °C",
    "jan": 1.5,
    "feb": 4.7,
    "mar": 10.4,
    "apr": 17.8,
    "may": 23,
    "jun": 27.1,
    "jul": 28.6,
    "aug": 29.6,
    "sep": 25.8,
    "oct": 19.8,
    "nov": 11.6,
    "dec": 4.3,
    "year": 17
  },
  {
    "id": 46,
    "location": "Seoul",
    "param": "Mean °C",
    "jan": -2.4,
    "feb": 0.4,
    "mar": 5.7,
    "apr": 12.5,
    "may": 17.8,
    "jun": 22.2,
    "jul": 24.9,
    "aug": 25.7,
    "sep": 21.2,
    "oct": 14.8,
    "nov": 7.2,
    "dec": 0.4,
    "year": 12.5
  },
  {
    "id": 47,
    "location": "Seoul",
    "param": "Low °C",
    "jan": -5.9,
    "feb": -3.4,
    "mar": 1.6,
    "apr": 7.8,
    "may": 13.2,
    "jun": 18.2,
    "jul": 21.9,
    "aug": 22.4,
    "sep": 17.2,
    "oct": 10.3,
    "nov": 3.2,
    "dec": -3.2,
    "year": 8.6
  },
  {
    "id": 48,
    "location": "Seoul",
    "param": "Rain mm",
    "jan": 20.8,
    "feb": 25,
    "mar": 47.2,
    "apr": 64.5,
    "may": 105.9,
    "jun": 133.2,
    "jul": 394.7,
    "aug": 364.2,
    "sep": 169.3,
    "oct": 51.8,
    "nov": 52.5,
    "dec": 21.5,
    "year": 1450.5
  },
  {
    "id": 49,
    "location": "Seoul",
    "param": "Rain days",
    "jan": 6.5,
    "feb": 5.8,
    "mar": 7.4,
    "apr": 7.8,
    "may": 9,
    "jun": 9.9,
    "jul": 16.3,
    "aug": 14.6,
    "sep": 9.1,
    "oct": 6.3,
    "nov": 8.7,
    "dec": 7.4,
    "year": 108.8
  },
  {
    "id": 50,
    "location": "Siam Reap",
    "param": "High °C",
    "jan": 31.7,
    "feb": 33.5,
    "mar": 34.9,
    "apr": 35.8,
    "may": 34.8,
    "jun": 33.6,
    "jul": 32.9,
    "aug": 32.4,
    "sep": 31.7,
    "oct": 31.5,
    "nov": 31.2,
    "dec": 30.6,
    "year": 32.9
  },
  {
    "id": 51,
    "location": "Siam Reap",
    "param": "Mean °C",
    "jan": 26,
    "feb": 27.8,
    "mar": 29.5,
    "apr": 30.5,
    "may": 29.9,
    "jun": 29.2,
    "jul": 28.9,
    "aug": 28.8,
    "sep": 28.1,
    "oct": 28,
    "nov": 26.9,
    "dec": 25.6,
    "year": 28.3
  },
  {
    "id": 52,
    "location": "Siam Reap",
    "param": "Low °C",
    "jan": 20.4,
    "feb": 22.4,
    "mar": 24.1,
    "apr": 25.4,
    "may": 25.4,
    "jun": 25.1,
    "jul": 24.9,
    "aug": 25.1,
    "sep": 24.7,
    "oct": 24.5,
    "nov": 22.6,
    "dec": 20.7,
    "year": 23.8
  },
  {
    "id": 53,
    "location": "Siam Reap",
    "param": "Rain mm",
    "jan": 3.7,
    "feb": 4.7,
    "mar": 29,
    "apr": 57.3,
    "may": 149.7,
    "jun": 214.1,
    "jul": 192.6,
    "aug": 208.9,
    "sep": 287.7,
    "oct": 199.6,
    "nov": 51.3,
    "dec": 7.3,
    "year": 1405.9
  },
  {
    "id": 54,
    "location": "Siam Reap",
    "param": "Rain days",
    "jan": 1.5,
    "feb": 0.7,
    "mar": 3.2,
    "apr": 7.6,
    "may": 17,
    "jun": 18,
    "jul": 17.6,
    "aug": 17.6,
    "sep": 17.4,
    "oct": 15.4,
    "nov": 6.4,
    "dec": 2,
    "year": 124.4
  },
  {
    "id": 55,
    "location": "Singapore",
    "param": "High °C",
    "jan": 30.1,
    "feb": 31.2,
    "mar": 31.6,
    "apr": 31.7,
    "may": 31.6,
    "jun": 31.3,
    "jul": 30.9,
    "aug": 30.9,
    "sep": 30.9,
    "oct": 31.1,
    "nov": 30.6,
    "dec": 30,
    "year": 31
  },
  {
    "id": 56,
    "location": "Singapore",
    "param": "Mean °C",
    "jan": 26,
    "feb": 26.5,
    "mar": 27,
    "apr": 27.4,
    "may": 27.7,
    "jun": 27.7,
    "jul": 27.4,
    "aug": 27.3,
    "sep": 27.2,
    "oct": 27,
    "nov": 26.5,
    "dec": 26,
    "year": 26.98
  },
  {
    "id": 57,
    "location": "Singapore",
    "param": "Low °C",
    "jan": 23.3,
    "feb": 23.6,
    "mar": 23.9,
    "apr": 24.4,
    "may": 24.8,
    "jun": 24.8,
    "jul": 24.6,
    "aug": 24.5,
    "sep": 24.2,
    "oct": 24.1,
    "nov": 23.7,
    "dec": 23.5,
    "year": 24.1
  },
  {
    "id": 58,
    "location": "Singapore",
    "param": "Rain mm",
    "jan": 243.2,
    "feb": 159.9,
    "mar": 185.7,
    "apr": 178.9,
    "may": 171.3,
    "jun": 162.1,
    "jul": 158.7,
    "aug": 175.4,
    "sep": 169.2,
    "oct": 193.8,
    "nov": 256.9,
    "dec": 287.4,
    "year": 2342.5
  },
  {
    "id": 59,
    "location": "Singapore",
    "param": "Rain days",
    "jan": 15,
    "feb": 11,
    "mar": 14,
    "apr": 15,
    "may": 15,
    "jun": 13,
    "jul": 13,
    "aug": 14,
    "sep": 14,
    "oct": 16,
    "nov": 19,
    "dec": 19,
    "year": 178
  },
  {
    "id": 60,
    "location": "Taipei",
    "param": "High °C",
    "jan": 19.1,
    "feb": 19.6,
    "mar": 22.1,
    "apr": 25.7,
    "may": 29.2,
    "jun": 32,
    "jul": 34.3,
    "aug": 33.8,
    "sep": 31.1,
    "oct": 27.5,
    "nov": 24.2,
    "dec": 20.7,
    "year": 26.6
  },
  {
    "id": 61,
    "location": "Taipei",
    "param": "Mean °C",
    "jan": 16.1,
    "feb": 16.5,
    "mar": 18.5,
    "apr": 21.9,
    "may": 25.2,
    "jun": 27.7,
    "jul": 29.6,
    "aug": 29.2,
    "sep": 27.4,
    "oct": 24.5,
    "nov": 21.5,
    "dec": 17.9,
    "year": 23
  },
  {
    "id": 62,
    "location": "Taipei",
    "param": "Low °C",
    "jan": 13.9,
    "feb": 14.2,
    "mar": 15.8,
    "apr": 19,
    "may": 22.3,
    "jun": 24.6,
    "jul": 26.3,
    "aug": 26.1,
    "sep": 24.8,
    "oct": 22.3,
    "nov": 19.3,
    "dec": 15.6,
    "year": 20.4
  },
  {
    "id": 63,
    "location": "Taipei",
    "param": "Rain mm",
    "jan": 83.2,
    "feb": 170.3,
    "mar": 180.4,
    "apr": 177.8,
    "may": 234.5,
    "jun": 325.9,
    "jul": 245.1,
    "aug": 322.1,
    "sep": 360.5,
    "oct": 148.9,
    "nov": 83.1,
    "dec": 73.3,
    "year": 2405.1
  },
  {
    "id": 64,
    "location": "Taipei",
    "param": "Rain days",
    "jan": 14.1,
    "feb": 14.6,
    "mar": 15.5,
    "apr": 14.9,
    "may": 14.8,
    "jun": 15.5,
    "jul": 12.3,
    "aug": 14,
    "sep": 13.8,
    "oct": 11.9,
    "nov": 12.4,
    "dec": 11.7,
    "year": 165.5
  },
  {
    "id": 65,
    "location": "Tokyo",
    "param": "High °C",
    "jan": 9.6,
    "feb": 10.4,
    "mar": 13.6,
    "apr": 19,
    "may": 22.9,
    "jun": 25.5,
    "jul": 29.2,
    "aug": 30.8,
    "sep": 26.9,
    "oct": 21.5,
    "nov": 16.3,
    "dec": 11.9,
    "year": 19.8
  },
  {
    "id": 66,
    "location": "Tokyo",
    "param": "Mean °C",
    "jan": 5.2,
    "feb": 5.7,
    "mar": 8.7,
    "apr": 13.9,
    "may": 18.2,
    "jun": 21.4,
    "jul": 25,
    "aug": 26.4,
    "sep": 22.8,
    "oct": 17.5,
    "nov": 12.1,
    "dec": 7.6,
    "year": 15.4
  },
  {
    "id": 67,
    "location": "Tokyo",
    "param": "Low °C",
    "jan": 0.9,
    "feb": 1.7,
    "mar": 4.4,
    "apr": 9.4,
    "may": 14,
    "jun": 18,
    "jul": 21.8,
    "aug": 23,
    "sep": 19.7,
    "oct": 14.2,
    "nov": 8.3,
    "dec": 3.5,
    "year": 11.6
  },
  {
    "id": 68,
    "location": "Tokyo",
    "param": "Rain mm",
    "jan": 52.3,
    "feb": 56.1,
    "mar": 117.5,
    "apr": 124.5,
    "may": 137.8,
    "jun": 167.7,
    "jul": 153.5,
    "aug": 168.2,
    "sep": 209.9,
    "oct": 197.8,
    "nov": 92.5,
    "dec": 51,
    "year": 1528.8
  },
  {
    "id": 69,
    "location": "Tokyo",
    "param": "Rain days",
    "jan": 5.3,
    "feb": 6.2,
    "mar": 11,
    "apr": 11,
    "may": 11.4,
    "jun": 12.7,
    "jul": 11.8,
    "aug": 9,
    "sep": 12.2,
    "oct": 10.8,
    "nov": 7.6,
    "dec": 4.9,
    "year": 114
  },
  {
    "id": 70,
    "location": "Yangoon",
    "param": "High °C",
    "jan": 32.2,
    "feb": 34.5,
    "mar": 36,
    "apr": 37,
    "may": 33.4,
    "jun": 30.2,
    "jul": 29.7,
    "aug": 29.6,
    "sep": 30.4,
    "oct": 31.5,
    "nov": 32,
    "dec": 31.5,
    "year": 32.3
  },
  {
    "id": 71,
    "location": "Yangoon",
    "param": "Mean °C",
    "jan": 25.1,
    "feb": 26.9,
    "mar": 28.8,
    "apr": 30.7,
    "may": 29.2,
    "jun": 27.4,
    "jul": 26.9,
    "aug": 26.9,
    "sep": 27.3,
    "oct": 27.9,
    "nov": 27.2,
    "dec": 25.3,
    "year": 27.5
  },
  {
    "id": 72,
    "location": "Yangoon",
    "param": "Low °C",
    "jan": 17.9,
    "feb": 19.3,
    "mar": 21.6,
    "apr": 24.3,
    "may": 25,
    "jun": 24.5,
    "jul": 24.1,
    "aug": 24.1,
    "sep": 24.2,
    "oct": 24.2,
    "nov": 22.4,
    "dec": 19,
    "year": 22.6
  },
  {
    "id": 73,
    "location": "Yangoon",
    "param": "Rain mm",
    "jan": 5,
    "feb": 2,
    "mar": 7,
    "apr": 15,
    "may": 303,
    "jun": 547,
    "jul": 559,
    "aug": 602,
    "sep": 368,
    "oct": 206,
    "nov": 60,
    "dec": 7,
    "year": 2681
  },
  {
    "id": 74,
    "location": "Yangoon",
    "param": "Rain days",
    "jan": 0.2,
    "feb": 0.2,
    "mar": 0.4,
    "apr": 1.6,
    "may": 12.6,
    "jun": 25.3,
    "jul": 26.2,
    "aug": 26.1,
    "sep": 19.5,
    "oct": 12.2,
    "nov": 4.8,
    "dec": 0.2,
    "year": 129.3
  }
 ];